import React from 'react';
import { Page, Text, View, Document, StyleSheet, Font, } from '@react-pdf/renderer';
import { OpForPDFType } from "../../Modals/ViewPCP/GenerateInspectionForm";




const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 11,
    fontFamily: 'Helvetica',
    color: '#000',
  },

  container: {
    border: '2px solid #000',
    width: '100%',
  },

  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    alignItems: 'stretch', // Garante que as colunas tenham a mesma altura
  },
  tableCell: {
    borderRightWidth: 1,
    borderRightColor: '#000',
    padding: 4,
    justifyContent: 'center',
  },
  lastCell: {
    borderRightWidth: 0,
  },
  noBorderBottom: {
    borderBottomWidth: 0,
  },

  textCenter: { textAlign: 'center' },
  textLeft: { textAlign: 'left' },
  textRight: { textAlign: 'right' },
  bold: { fontFamily: 'Helvetica-Bold', fontWeight: 'bold' },
  smallText: { fontSize: 8 }, // Ajustado para 8-9px visualmente
  tinyText: { fontSize: 7 },


  headerLogo: { width: '15%' },
  headerTitle: { width: '65%', backgroundColor: '#f0f0f0' },
  headerMeta: { width: '20%', fontSize: 9 },


  inputLine: {
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    marginTop: 10,
  },


  descHeader: {
    fontFamily: 'Times-Roman', // Serifado como no HTML
    fontSize: 14,
    textTransform: 'uppercase',
    padding: 8,
    borderBottomWidth: 2,
    borderBottomColor: '#000',
  },


  checkBox: {
    width: 10,
    height: 10,
    borderWidth: 1,
    borderColor: '#000',
    marginRight: 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },


  colPeca: { width: '8%' },
  colRE: { width: '8%' },
  colDim: { width: '11%' },
  colAcab: { width: '16%' },
  colIdent: { width: '16%' },
  colLaudo: { width: '5%' },
});


const CheckBox = ({ label, checked = false }: { label?: string, checked?: boolean }) => (
  <View style={styles.checkContainer}>
    <View style={styles.checkBox}>
      {checked && <Text style={{ fontSize: 8, lineHeight: 1 }}>X</Text>}
    </View>
    {label && <Text style={{ marginRight: 5 }}>{label}</Text>}
  </View>
);

interface InspectionPDFProps {
  data?: OpForPDFType | null;
}

type StockInProductionItem = NonNullable<OpForPDFType['StockInProduction']>[number];

const getReValue = (description?: string | null): string => {
  if (!description) return '';

  const match = description.match(/\bRE\s*([0-9]+(?:\/[0-9]+)?)\b/i);
  return match ? match[1] : description;
};

const getReRanges = (items: StockInProductionItem[]): Map<string, { first: number; last: number }> => {
  const ranges = new Map<string, { first: number; last: number }>();

  items.forEach((item, index) => {
    const reValue = getReValue(item?.Stock?.description);
    if (!reValue) return;
    const position = index + 1;
    const current = ranges.get(reValue);

    if (!current) {
      ranges.set(reValue, { first: position, last: position });
      return;
    }

    ranges.set(reValue, { first: current.first, last: position });
  });

  return ranges;
};

const getUniqueItemsByRe = (items: StockInProductionItem[]): StockInProductionItem[] => {
  const unique = new Map<string, StockInProductionItem>();

  items.forEach((item) => {
    const reValue = getReValue(item?.Stock?.description);
    if (!reValue) return;
    if (!unique.has(reValue)) unique.set(reValue, item);
  });

  return Array.from(unique.values());
};

const InspectionPDF: React.FC<InspectionPDFProps> = ({ data }) => {
  const stockItems = data?.StockInProduction ?? [];
  const reRanges = getReRanges(stockItems);
  return (
    <Document>
      <Page size="A4" style={styles.page}>

        {}
        <View style={styles.container}>

          {}
          <View style={styles.tableRow}>
            <View style={[styles.tableCell, styles.headerLogo, styles.textCenter, { justifyContent: 'center' }]}>
              <Text style={styles.bold}>DUSTRE</Text>
            </View>
            <View style={[styles.tableCell, styles.headerTitle, styles.textCenter, { justifyContent: 'center' }]}>
              <Text style={styles.bold}>RELATÓRIO DE INSPEÇÃO FINAL</Text>
            </View>
            <View style={[styles.tableCell, styles.headerMeta, styles.lastCell, styles.textCenter, { justifyContent: 'center' }]}>
              <Text style={styles.bold}>Rev 06</Text>
              <Text>Data: 09/02/2026	</Text>
            </View>
          </View>

          {}
          <View style={[styles.tableRow, { padding: 4, flexDirection: 'column' }]}>
            <Text style={styles.smallText}>
              <Text style={styles.bold}>Legenda:</Text> OP Ordem de Produção; B - Bruto; U - Usinado; CF - Conforme; NCF - Não conforme; A - Aprovado; R Reprovado;
            </Text>
            <Text style={[styles.smallText, { marginTop: 2 }]}>
              <Text style={styles.bold}>Nota:</Text> A inspeção visual abrange a verificação do acabamento das peças (B ou U), da ausência de defeitos visíveis (trincas, poros, rebarbas, cantos vivos etc.), e conferência da identificação / rastreabilidade da peça.
            </Text>
          </View>

          {}
          {}
          <View style={styles.tableRow}>
            <View style={[styles.tableCell, { width: '15%' }]}>
              <Text style={styles.bold}>CLIENTE: </Text>
            </View>
            <View style={[styles.tableCell, { width: '85%' }]}>
              <Text>{data?.OrderItem?.Order?.Company_Order_clientIdToCompany?.companyName || ''}</Text>
            </View>
          </View>
          <View style={styles.tableRow}>

            <View style={[styles.tableCell, { width: '15%' }]}>
              <Text style={styles.bold}>DATA:</Text>
            </View>
            <View style={[styles.tableCell, { width: '35%', borderRightWidth: 0 }]}>
              <Text>{ }</Text>
            </View>
            
            <View style={[styles.tableCell, { width: '15%' }]}>
              <Text style={styles.bold}>Inspetor:</Text>
            </View>

            <View style={[styles.tableCell, { width: '35%', borderRightWidth: 0 }]}>
              <Text>{ }</Text>
            </View>
          </View>
          {}
          <View style={styles.tableRow}>
            <View style={[styles.tableCell, { width: '10%' }]}>
              <Text style={styles.bold}>N° OP:</Text>
            </View>
            <View style={[styles.tableCell, { width: '15%' }]}>
              <Text>{data?.codeOfOP.split(' - ')[0] || ''}</Text>
            </View>
            <View style={[styles.tableCell, { width: '10%' }]}>
              <Text style={styles.bold}>Item:</Text>
            </View>
            <View style={[styles.tableCell, { width: '15%', borderRightWidth: 0 }]}>
              <Text>{data?.codeOfOP.split(' - ')[1]}</Text>
            </View>
            <View style={[styles.tableCell, { width: '10%' }]}></View>
            <View style={[styles.tableCell, { width: '25%' }]}>
              <Text style={styles.bold}>INSTRUMENTOS:</Text>
            </View>
            <View style={[styles.tableCell, { width: '35%', borderRightWidth: 0, flexDirection: 'row', alignItems: 'center' }]}>
              <CheckBox label="Paquímetro" />
              <View style={{ width: 10 }} />
              <CheckBox label="Trena" />
            </View>
          </View>

          {}
          {}
          <View style={styles.tableRow}>
            <View style={[styles.tableCell, { width: '15%' }]}>
              <Text style={styles.bold}>Liga/Matéria Prima:</Text>
            </View>
            <View style={[styles.tableCell, { width: '85%', borderRightWidth: 0 }]}>
              <Text>{data?.OrderItem?.ploomesProductName}</Text>
            </View>
          </View>

          {}
          <View style={styles.tableRow}>
            <View style={[styles.tableCell, { width: '100%', borderRightWidth: 0, padding: 0 }]}>
              <View style={[styles.textCenter, { borderBottomWidth: 1, borderBottomColor: '#000' }]}>
                <Text style={[styles.descHeader, styles.bold, styles.textCenter]}>DESCRIÇÃO DO ITEM</Text>
              </View>

              {}
              <View style={{ flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#000' }}>
                <View style={{ width: '20%', borderRightWidth: 1, padding: 4 }}>
                  <Text style={[styles.bold, styles.textCenter]}>Dimensão (mm)</Text>
                </View>
                <View style={{ width: '40%', borderRightWidth: 1, padding: 4 }}>
                  <Text style={[styles.bold, styles.textCenter]}></Text>
                </View>
                <View style={{ width: '40%', padding: 4 }}>
                  <Text style={[styles.bold, styles.textCenter]}>Tolerância (mm)</Text>
                </View>
              </View>

              {}
              {['Diâmetro', 'Comprimento', 'Largura', 'Espessura'].map((label, index, arr) => (
                <View key={label} style={{ flexDirection: 'row', borderBottomWidth: index === arr.length - 1 ? 0 : 1, borderBottomColor: '#000' }}>
                  <View style={{ width: '20%', borderRightWidth: 1, padding: 4 }}>
                    <Text style={styles.bold}>{label}</Text>
                  </View>
                  <View style={{ width: '40%', borderRightWidth: 1, padding: 4 }}>
                    <Text> </Text>
                  </View>
                  <View style={{ width: '40%', padding: 4 }}>
                    <Text> </Text>
                  </View>
                </View>
              ))}
            </View>
          </View>

          {}
          {}
          <View style={[styles.tableRow, { backgroundColor: '#f0f0f0' }]}>
            <View style={[styles.tableCell, { width: '100%', borderRightWidth: 0, padding: 6 }]}>
              <Text style={[styles.bold, styles.textCenter]}>RESULTADOS DAS MEDIÇÕES</Text>
            </View>
          </View>

          {}
          <View style={[styles.tableRow, styles.textCenter, { fontSize: 8 }]}>
            <View style={[styles.tableCell, styles.colPeca]}><Text style={styles.bold}>Peça</Text></View>
            <View style={[styles.tableCell, styles.colRE]}><Text style={styles.bold}>RE</Text></View>
            <View style={[styles.tableCell, styles.colDim]}><Text style={styles.bold}>Diâmetro</Text></View>
            <View style={[styles.tableCell, styles.colDim]}><Text style={styles.bold}>Comprimento</Text></View>
            <View style={[styles.tableCell, styles.colDim]}><Text style={styles.bold}>Largura</Text></View>
            <View style={[styles.tableCell, styles.colDim]}><Text style={styles.bold}>Espessura</Text></View>
            <View style={[styles.tableCell, styles.colAcab]}><Text style={styles.bold}>Acabamento</Text></View>
            <View style={[styles.tableCell, styles.colIdent]}><Text style={styles.bold}>Identificação</Text></View>
            <View style={[styles.tableCell, styles.colLaudo]}><Text style={styles.bold}>A</Text></View>
            <View style={[styles.tableCell, styles.colLaudo, styles.lastCell]}><Text style={styles.bold}>R</Text></View>
          </View>

          {}
          {getUniqueItemsByRe(stockItems).map((item) => {
            const reValue = getReValue(item?.Stock?.description);
            const range = reValue ? reRanges.get(reValue) : undefined;
            const rangeText = range ? `${range.first}-${range.last}` : '';
            return (
              <View key={reValue || item.id} style={[styles.tableRow, { height: 25 }]}>
                <View style={[styles.tableCell, styles.colPeca]}><Text>{rangeText}</Text></View>
                <View style={[styles.tableCell, styles.colRE]}><Text>{reValue}</Text></View>
                <View style={[styles.tableCell, styles.colDim]}><Text>{ }</Text></View>
                <View style={[styles.tableCell, styles.colDim]}><Text>{ }</Text></View>
                <View style={[styles.tableCell, styles.colDim]}><Text>{ }</Text></View>
                <View style={[styles.tableCell, styles.colDim]}><Text>{ }</Text></View>
                {}
                <View style={[styles.tableCell, styles.colAcab, { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', fontSize: 7 }]}>
                  <CheckBox label="B" />
                  <CheckBox label="U" />
                </View>

                {}
                <View style={[styles.tableCell, styles.colIdent, { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', fontSize: 7 }]}>
                  <CheckBox label="CF" />
                  <CheckBox label="NCF" />
                </View>

                {}
                <View style={[styles.tableCell, styles.colLaudo, { alignItems: 'center' }]}>
                  <CheckBox />
                </View>
                <View style={[styles.tableCell, styles.colLaudo, styles.lastCell, { alignItems: 'center' }]}>
                  <CheckBox />
                </View>

              </View>
            );
          })}
          {[1, 3].map((i) => {
            return (
              <View key={i || i} style={[styles.tableRow, { height: 25 }]}>
                <View style={[styles.tableCell, styles.colPeca]}><Text>{ }</Text></View>
                <View style={[styles.tableCell, styles.colRE]}><Text>{ }</Text></View>
                <View style={[styles.tableCell, styles.colDim]}><Text>{ }</Text></View>
                <View style={[styles.tableCell, styles.colDim]}><Text>{ }</Text></View>
                <View style={[styles.tableCell, styles.colDim]}><Text>{ }</Text></View>
                <View style={[styles.tableCell, styles.colDim]}><Text>{ }</Text></View>
                {}
                <View style={[styles.tableCell, styles.colAcab, { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', fontSize: 7 }]}>
                  <CheckBox label="B" />
                  <CheckBox label="U" />
                </View>

                {}
                <View style={[styles.tableCell, styles.colIdent, { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', fontSize: 7 }]}>
                  <CheckBox label="CF" />
                  <CheckBox label="NCF" />
                </View>

                {}
                <View style={[styles.tableCell, styles.colLaudo, { alignItems: 'center' }]}>
                  <CheckBox />
                </View>
                <View style={[styles.tableCell, styles.colLaudo, styles.lastCell, { alignItems: 'center' }]}>
                  <CheckBox />
                </View>

              </View>
            )
          })}

          {}
          {}
          <View style={styles.tableRow}>
            <View style={[styles.tableCell, { width: '100%', height: 40, borderRightWidth: 0, justifyContent: 'flex-start' }]}>
              <Text style={styles.bold}>Relatório visual:</Text>
            </View>
          </View>

          {}
          <View style={styles.tableRow}>
            <View style={[styles.tableCell, { width: '100%', height: 40, borderRightWidth: 0, justifyContent: 'flex-start' }]}>
              <Text style={styles.bold}>Observações:</Text>
            </View>
          </View>

          {}
          <View style={[styles.tableRow, { backgroundColor: '#f0f0f0' }]}>
            <View style={[styles.tableCell, { width: '100%', borderRightWidth: 0, padding: 4 }]}>
              <Text style={[styles.bold, styles.textCenter]}>APROVAÇÃO DO SETOR DE QUALIDADE</Text>
            </View>
          </View>

          {}
          <View style={styles.tableRow}>
            {}
            <View style={[styles.tableCell, { width: '50%', height: 40, justifyContent: 'flex-end' }]}>
              <View style={{ flexDirection: 'row', justifyContent: 'space-around', marginBottom: 5 }}>
                <CheckBox label="Aprovado" />
                <CheckBox label="Reprovado" />
              </View>
            </View>

            {}
            <View style={[styles.tableCell, { width: '50%', borderRightWidth: 0, height: 40, justifyContent: 'flex-end' }]}>
              <Text style={{ marginBottom: 5 }}><Text style={styles.bold}>Data:</Text> _______/_______/_______</Text>
            </View>
          </View>

          {}
          <View style={[styles.tableRow, styles.noBorderBottom]}>
            <View style={[styles.tableCell, { width: '100%', height: 35, borderRightWidth: 0, justifyContent: 'flex-end' }]}>
              <Text style={{ marginBottom: 5 }}><Text style={styles.bold}>Responsável:</Text> __________________________________________________</Text>
            </View>
          </View>

        </View>
      </Page>
    </Document>
  );
};

export default InspectionPDF;